<template>
  <div class="category-nav">
    <i class="icon-chevron-down bounce"/>
    <!--<el-row
      :span="20"
      class="category-nav-content">
      <el-col :span="5">
        <div class="music">
          <i class="icon-music-icon"/>
          <span>Música</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="sports">
          <i class="icon-sports-icon"/>
          <span>Deportes</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="arts">
          <i class="icon-arts-icon"/>
          <span>Arte y cultura</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="kids">
          <i class="icon-kids-icon"/>
          <span>Niños</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="special">
          <i class="icon-special-icon"/>
          <span>Especiales</span>
        </div>
      </el-col>
    </el-row>-->
  </div>
</template>

<script>
export default {
  name: 'NavFooter'
}
</script>

<style lang="scss" scoped>
  .bounce {
    -moz-animation: bounce 2s infinite;
    -webkit-animation: bounce 2s infinite;
    animation: bounce 2s infinite;
  }
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-30px);
    }
    60% {
      transform: translateY(-15px);
    }
  }
  .category-nav{
    height: 120px;
    background-color: transparent;
    width: 100%;
    ///////
    display: flex;
    align-items: flex-end;
    i{
      color: white;
      font-size: 42px;
      font-weight: lighter;
      margin: 0 auto;
    }
    @media #{$Elementxs} {
      display: none;
    }
    .category-nav-content{
      width: 1280px;
      margin: 0 auto;
      @media #{$Laptop} {
        width: 100%;
      }
    }
    .el-row{
      height: 120px;
      display: flex;
      align-items: center;
      .el-col{
        color: white;
        display: flex;
        align-items: center;
        div{
          margin: 0 auto;
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 20px;
          i{
            font-size: 28px;
            color: white;
            margin-right: 17px;
          }
          span{
            @include font-primary(18px, light);
            color: white;
          }
        }
        &:hover{
          .icon-music-icon{color: $music}
          .icon-sports-icon{color: $sports}
          .icon-arts-icon{color: $arts}
          .icon-kids-icon{color: $kids }
          .icon-special-icon{color: $special}
          span{color: white;}
        }
      }
    }
  }

  //MEDIA QUERIE//
  @media screen and (max-width: 986px){
    i{
      @include font-primary(40px !important, light);
      margin-right: 0 !important;
    }
  span{
    display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue